import gamename from "../util/gameName";
import environment from "../util/environment";

const localUserData = {
  "locale": "ko-KR",
  "now": "2018-10-10T14:03:16.750+09:00",
  "site": "lineage1",
  "guid": "",
  "uesAccountType": "gameAccount",
  "ncAccount": {
    "name": "",
    "profileImage": "",
    "url": "",
    "target": ""
  },
  "gameAccount": {
    "name": "",
    "profileImage": "",
    "url": "",
    "subData": []
  },
  "nshop": {
    "nCoin": "0",
    "coupon": "0"
  },
  "login": false,
  "accountState": []
};

const api = {
  lineage: {
    local: "",
    rc: "https://rc-apilineage.plaync.com/api/main/cnb/userData",
    live: "https://api-lineage.plaync.com/api/main/cnb/userData"
  },
  aion: {
    local: "",
    rc: "http://rc-api.aion.plaync.com/webcontents/v2/cnb/userData",
    live: "http://api-aion.plaync.com/webcontents/v2/cnb/userData"
  }
};

const coupon = {
  lineage: {
    local: "",
    rc: "http://rc.lineagenshop.plaync.com/lineage/coupon/popup/couponProfileRegisterForm?gameCode=31",
    live: "http://lineagenshop.plaync.com/lineage/coupon/popup/couponProfileRegisterForm?gameCode=31"
  },
  aion: {
    local: "",
    rc: "http://rc.aionnshop.plaync.com/aion/coupon/popup/couponProfileRegisterForm?gameCode=27",
    live: "http://aionnshop.plaync.com/aion/coupon/popup/couponProfileRegisterForm?gameCode=27"
  }
};

const size = {
  lineage: {
    "width": 82,
    "height": 26,
    "marginTop": 15
  },
  aion: {
    "width": 81,
    "height": 30,
    "marginTop": 13
  }
};

class Cnb {
  constructor(options){
    const gameInfo = gamename();
    const lan = environment();
    const apiUrl = api[gameInfo.en][lan];
    const couponUrl = coupon[gameInfo.en][lan];
    const style = size[gameInfo.en];
    
    let cnbConfig = {
      "type": "B",
      "bi": {
        "title": `${gameInfo.en}`,
        "url": "/",
        "image": {}
      },
      "header": {
        "large": "rgba(16,16,16,0.8)",
        "medium": "rgba(16,16,16,0.8)",
        "mediumSticky": "#5c443b",
        "lnb": "#c69c7c"
      },
      "useLeftMenu": true,
      "useJoinMenu": true,
      "joinURL": `http://search.plaync.com/${gameInfo.en}/index.jsp`,
      "useGameStart": "mobileGameDown",
      "gameStart": {
        "markUp": "<a href=\"#\" class=\"ncc-gamestart-btn__start\">다운로드</a>"
      },
      "mobileGameDown": {
        "showAndro": true,
        "showIos": true,
        "appName": "",
        "iosAppLink": "",
        "androAppLink": ""
      },
      "search": {
        "isShow": false,
        "destUrl": `http://search.plaync.com/${gameInfo.en}/index.jsp`,
        "site": `${gameInfo.en}`,
        "callback": "suggestKeyword",
        "collection": `${gameInfo.en}1query`,
        "display": 10,
        "pos": "lnb",
        "where": `${gameInfo.en}^tsearch`
      },
      "lnbData": [],
      "active": {
        "d1": 0,
        "d2": 0
      },
      "shortCut": {
        enterCoupon: {
          url: couponUrl
        }
      },
      "appDownloadData": {
        "isShow": false,
        "appList": []
      },
      "loginFN": "GNBLogin",
      "logoutFN": "GNBLogout",
      "useCharChangeMenu": false,
      "charChangeFN": "characterChange"
    };
    
    if(typeof options.image === "object"){
      cnbConfig.bi.image = {
        "large": {
          "path": options.image.large,
          "style": style
        },
        "medium": {
          "path": options.image.medium,
          "style": style
        },
        "sticky": {
          "path": options.image.mediumSticky,
          "style": style
        },
        "lnb": {
          "path": options.image.lnb,
          "style": style
        }
      };
    } else {
      cnbConfig.bi.image = {
        "path": options.image,
        "style": style
      };
    }
    
    cnbConfig.header = options.color;
    
    if(!apiUrl){
      let data = localUserData;
      window.userData = data;
      window.userData.isLogin = data.login;
      window.cnb.start(cnbConfig);
    } else {
      $.ajax({
        url: apiUrl,
        xhrFields: {withCredentials: true}
      }).done(function (data){
        window.userData = data;
        window.userData.isLogin = data.login;
        window.cnb.start(cnbConfig);
      });
    }
    
    //제제계정 본인확인 팝업
    window.openPopup = function (obj, objWidth, objHeight, objName, objScroll, deny, objFull, addParam){
      try {
        if(objScroll !== 1 && objScroll !== 0 && objScroll !== "1" && objScroll !== "0"){
          var objScrollCopy = objScroll;
          objScroll = objName;
          objName = objScrollCopy;
        }
        
        if(typeof(obj) == "string"){
          var setup = "width=" + objWidth + ",height=" + objHeight + ",toolbar=no,location=no,status=no,menubar=no,top=20,left=20,scrollbars=" + objScroll + ",resizable=no";
          if(objName == "" || !objName) objName = "popup";
          if(objFull) setup = "fullscreen=1,scrollbars=0";
          
          var win = window.open(obj, objName, setup);
          if(win != null) win.focus();
          
          return win;
        }
        
        if(!objName) objName = "popup";
        if(!objScroll) objScroll = "auto";
        
        var url = addParam ? obj.href + "?" + addParam : obj.href;
        var setup = "width=" + objWidth + ",height=" + objHeight + ",toolbar=no,location=no,status=no,menubar=no,top=20,left=20,scrollbars=" + objScroll + ",resizable=no";
        
        if(objFull) setup = "fullscreen=1,scrollbars=0";
        var win = window.open(url, objName, setup);
        
        if(deny){
          if(win == null){
            alert("팝업 차단을 해제하여 주시기 바랍니다.");
          } else {
            win.focus();
          }
        }
        
        return win;
        
      } catch (e) {
        //
      }
    };
    window.openPopupUnban = function (url){
      openPopup(url, 580, 370, "unban", 1, 1);
      return false;
    };
  }
}

export default Cnb;
